import { svg } from 'lit';

const symbol = svg`<svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 11L8 4.5l6.6 6.5" stroke="currentcolor" stroke-linecap="square"/></svg>`;

export { symbol as default };
